/**
 * 购物车结账 — 飞书营销机器人推送
 * 事件委托，适配购物车弹窗 AJAX 加载
 */
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-cart-button');
    if (!btn || btn.name !== 'checkout') return;
    try {
      if (!window.IVE_FEISHU_HOOK) return;
      var t = btn.dataset;
      var utm = window.iveUtm || {};
      var u = '';
      if (utm.utm_source) u += 'utm_source=' + utm.utm_source;
      if (utm.utm_medium) u += (u ? ', ' : '') + 'utm_medium=' + utm.utm_medium;
      if (utm.utm_campaign) u += (u ? ', ' : '') + 'utm_campaign=' + utm.utm_campaign;
      var msg = '💳 购物车结账\n' +
        '总金额：' + (t.cartTotal || 'N/A') + '\n' +
        '商品数：' + (t.cartCount || '0') + '\n' +
        '商品：' + (t.cartItems || 'N/A') + '\n' +
        '国家：' + (t.userCountry || 'N/A') + '\n' +
        (u ? 'UTM：' + u + '\n' : '') +
        '时间：' + new Date().toLocaleString() + '\n' +
        '链接：' + window.location.href;
      fetch(window.IVE_FEISHU_HOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ msg_type: 'text', content: { text: msg } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  });
});
